const archiveRoutes = [
  {
    path: "/cdr",
    name: "Monthly Usage Reports",
    icon: "icon cafe-doc-folder",
  },
];

export default archiveRoutes;
